import { Route } from 'react-router-dom'
import { lazy } from 'react'

const PatientData = lazy(() => import('./pages/PatientData'))
const DependentSuccess = lazy(() => import('./pages/DependentSuccess'))
const Identifier = lazy(() => import('./pages/Identifier'))

const ActivationRoutes = [
  <Route
    path="/ativacao/dados-usuario"
    key="/ativacao/dados-usuario"
    exact
    component={PatientData}
  />,
  <Route
    path="/ativacao/dados-dependente/:dependentId"
    key="/ativacao/dados-dependente/:dependentId"
    exact
    component={PatientData}
  />,
  <Route
    path="/ativacao/atualizar/dados-dependente/:dependentId"
    key="/ativacao/atualizar/dados-dependente/:dependentId"
    exact
    component={PatientData}
  />,
  <Route
    path="/ativacao/conta-dependente-ativada"
    key="/ativacao/conta-dependente-ativada"
    exact
    component={DependentSuccess}
  />,
  <Route
    path="/ativacao/conta-dependente-dados-atualizados"
    key="/ativacao/conta-dependente-dados-atualizados"
    exact
    component={DependentSuccess}
  />,
  <Route
    path="/ativacao/identificador"
    key="/ativacao/identificador"
    exact
    component={Identifier}
  />,
]

export default ActivationRoutes
